import classNames from 'classnames';
import {
  Checkbox,
  Button,
  Select,
  Txt,
  Input,
  TitledBlock,
  FlexContainer,
  ContentBlock,
  View,
} from 'components';
import { userTitleOptions } from 'config/userFields';
import { useState } from 'react';
import { tenantDefault } from 'config/dataDefaults';
import setObjectKetValue from 'helpers/setObjectKetValue';
import styles from './TenantAddEditScreen.module.scss';
import { firstNameField, lastNameField, phoneField } from 'config/fieldsProps';

const initialState = tenantDefault();

/**
 * TenantAddEditScreen
 *
 * @return {JSX.Element}
 */
const TenantAddEditScreen = ({ className, tenant, onSave }) => {
  const [state, setState] = useState(() => ({
    ...initialState,
    ...tenant,
    guarantor: {
      ...initialState.guarantor,
      ...tenant?.guarantor,
    },
  }));

  const handleSubmit = (e) => {
    console.log('Submit');
    onSave(state);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleChange = ({ target: { name, value } }) => {
    console.log(name, value);
    setState((c) => ({ ...setObjectKetValue(c, name, value) }));
  };

  const handleChangeCheckbox = ({ target: { name, checked } }) => {
    setState((c) => ({ ...setObjectKetValue(c, name, checked) }));
  };

  return (
    <ContentBlock
      className={classNames(
        styles.TenantAddEditScreen,
        className,
        TenantAddEditScreen.displayName
      )}
      grey
      column
      gap
    >
      <View className={styles.Header}>
        <Txt xxxx>{tenant ? 'Edit' : 'Add'} tenant info</Txt>
      </View>
      <form onSubmit={handleSubmit}>
        <FlexContainer column>
          <TitledBlock title="Title">
            <Select
              options={userTitleOptions}
              name="title"
              value={state.title}
              onChange={handleChange}
              required
              fullWidth
            />
          </TitledBlock>
          <TitledBlock title="First name">
            <Input
              {...firstNameField}
              type="text"
              value={state.firstName}
              onChange={handleChange}
              fullWidth
            />
          </TitledBlock>
          <TitledBlock title="Last name">
            <Input
              {...lastNameField}
              type="text"
              value={state.lastName}
              onChange={handleChange}
              fullWidth
            />
          </TitledBlock>
          <TitledBlock title="Email address">
            <Input
              type="email"
              name="emailAddress"
              value={state.emailAddress}
              onChange={handleChange}
              required
              fullWidth
            />
          </TitledBlock>
          <TitledBlock title="Mobile number">
            <Input
              {...phoneField}
              value={state.mobileNumber}
              onChange={handleChange}
              fullWidth
            />
          </TitledBlock>
          <FlexContainer
            className={classNames(
              styles.GuarantorBlock,
              state.hasGuarantor && styles.GuarantorBlock__enabled
            )}
            column
          >
            <TitledBlock>
              <ContentBlock>
                <Checkbox
                  name="hasGuarantor"
                  reverse
                  toggler
                  checked={state.hasGuarantor}
                  onChange={handleChangeCheckbox}
                >
                  <FlexContainer column>
                    <Txt xx>Add Guarantor</Txt>
                    <Txt regular>
                      Including a guarantor can dilute the risk of taking on a
                      new tenant. That being said, it is not a requirement.
                    </Txt>
                  </FlexContainer>
                </Checkbox>
              </ContentBlock>
            </TitledBlock>
            {state.hasGuarantor ? (
              <>
                <TitledBlock title="Title">
                  <Select
                    options={userTitleOptions}
                    name="guarantor.title"
                    value={state.guarantor.title}
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                </TitledBlock>
                <TitledBlock title="First name">
                  <Input
                    type="text"
                    name="guarantor.firstName"
                    value={state.guarantor.firstName}
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                </TitledBlock>
                <TitledBlock title="Last name">
                  <Input
                    type="text"
                    name="guarantor.lastName"
                    value={state.guarantor.lastName}
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                </TitledBlock>
                <TitledBlock title="Email address">
                  <Input
                    type="email"
                    name="guarantor.emailAddress"
                    value={state.guarantor.emailAddress}
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                </TitledBlock>
                <TitledBlock title="Mobile number">
                  <Input
                    type="tel"
                    name="guarantor.mobileNumber"
                    value={state.guarantor.mobileNumber}
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                </TitledBlock>
              </>
            ) : null}
          </FlexContainer>
          <Button flex className={styles.Button} big success type="submit">
            <FlexContainer spaceBetween alignCenter flex>
              <Txt xx>{tenant ? 'Edit' : 'Add'} a Tenant</Txt>
            </FlexContainer>
          </Button>
        </FlexContainer>
      </form>
    </ContentBlock>
  );
};

TenantAddEditScreen.displayName = 'TenantAddEditScreen';

export default TenantAddEditScreen;
